import { toDateTime, isSameDay } from "@/lib/date-utils"
import { isIos } from "@/lib/is-platform"

export const generateURL = ({
  startsAt,
  endsAt,
  timezone,
  title,
  description
}) => {
  const params = {
    client: process.env.VUE_APP_ADD_EVENT_CLIENT_ID,
    start: toDateTime(startsAt, "MM/DD/YYYY HH:mm"),
    end: toDateTime(endsAt, "MM/DD/YYYY HH:mm"),
    timezone: timezone,
    title: title,
    description: description,
    all_day_event: !isSameDay(startsAt, endsAt),
    service: isIos() ? "apple" : "google"
  }

  return `https://www.addevent.com/dir/?${new URLSearchParams(
    params
  ).toString()}`
}
